exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lo_1d25284{display:flex;align-items:center;justify-content:center;background-color:#f6f8fa;background-color:var(--color-bg);background-image:url(/img/login.jpg);background-attachment:fixed;background-size:cover;background-repeat:no-repeat;height:100%}.lo_1d25284 .box_488f592{width:480px;padding:50px 80px 60px;border-radius:4px;box-shadow:0 15px 50px rgba(0,0,0,.5),2px 2px hsla(0,0%,100%,.5);background-color:hsla(0,0%,100%,.8)}@supports ((-webkit-backdrop-filter:blur(20px)) or (backdrop-filter:blur(20px))){.lo_1d25284 .box_488f592{-webkit-backdrop-filter:blur(25px);backdrop-filter:blur(25px);background-color:hsla(0,0%,100%,.1)}}.lo_1d25284 .g_026a083{margin-top:25px}.lo_1d25284 .icon_d0a80e2{width:20px;height:18px;color:#aaa}", ""]);

// exports
exports.locals = {
	"lo": "lo_1d25284",
	"box": "box_488f592",
	"g": "g_026a083",
	"icon": "icon_d0a80e2"
};